<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <router-link class="btn btn-primary mb-4" :to="{ path: '/dashboard/Gift' }">کد هدیه جدید</router-link>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>کد هدیه</th>
                    <th>کل / مصرف شده</th>
                    <th>تعداد روز</th>
                    <th>تعداد سکه</th>
                    <th>انقضا</th>
                    <th>وضعیت</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="gift in giftCodes" :key="gift._id">
                    <td>{{ gift.code }}</td>
                    <td>
                      <span class="text-success">{{ gift.maxUseCount }}</span> /
                      <span class="text-warning"> {{ gift.usedCount }}</span>
                    </td>
                    <td>{{ gift.days }}</td>
                    <td>{{ gift.coins }}</td>
                    <td>{{ gift.expireAble ? new Date(gift.expireDate).toLocaleString('fa-IR') : 'ندارد' }}</td>
                    <td>
                      <span v-if="gift.isActive" class="text-success"> فعال</span>
                      <span v-else class="text-danger">غیر فعال</span>
                    </td>
                    <td>
                      <router-link
                        class="btn btn-gradient-03 mr-3"
                        :to="{ path: '/dashboard/Gift', query: { id: gift._id } }"
                        >مشاهده</router-link
                      >

                      <!-- <button @click="edit(gift)" class="btn btn-gradient-03 mr-3">مشاهده</button> -->
                      <button @click="deleteCode(gift)" class="btn btn-gradient-01">حذف</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row" style="padding:9px 10px">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_info" id="sorting-table_info" role="status" aria-live="polite">
                    {{ `صفحه ${page.current} از ${page.total} - تعداد کل: ${page.count} ` }}
                  </div>
                </div>
                <div class="col-sm-12 col-md-6" style="direction:ltr">
                  <div class="dataTables_paginate paging_simple_numbers" id="sorting-table_paginate">
                    <ul class="pagination">
                      <!-- disabled -->
                      <li class="paginate_button page-item previous" id="sorting-table_previous">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="0"
                          tabindex="0"
                          class="page-link"
                          @click="getGifts({ page: page.pre })"
                          >قبلی</a
                        >
                      </li>
                      <li class="paginate_button page-item">
                        <a aria-controls="sorting-table" data-dt-idx="1" tabindex="0" class="page-link">{{
                          page.current
                        }}</a>
                      </li>
                      <li class="paginate_button page-item next" id="sorting-table_next">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="3"
                          tabindex="0"
                          class="page-link"
                          @click="getGifts({ page: page.next })"
                          >بعدی</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
    <AddEdit :modal="modalData" @clicked="addEdit" ref="form"></AddEdit>
  </div>
</template>

<script>
import giftService from '../../../../services/gift';
import _ from 'lodash';
export default {
  name: 'gift',
  components: {
    AddEdit: () => import('./AddEditGift'),
  },
  data() {
    return {
      giftCodes: [],
      modalData: {
        title: '',
        days: '',
        coins: '',
        maxUseCount: '',
        usedCount: '',
        code: '',
        deactiveForFirstUse: '',
        expireAble: '',
        expireDate: '',
        isActive: '',
      },
      page: {
        next: '',
        pre: '',
        current: '',
        total: '',
        count: '',
      },
    };
  },
  created() {
    this.getGifts({ conditions: {} });
  },
  methods: {
    addNew() {
      this.modalData = {
        title: 'کد هدیه جدید',
        days: '',
        coins: '',
        maxUseCount: '',
        usedCount: '',
        code: '',
        deactiveForFirstUse: 'true',
        expireAble: 'false',
        expireDate: '',
        isActive: 'true',
      };
      window.$('#CreatCodeModal').modal('show');
    },
    edit(gift) {
      this.modalData = _.clone(gift);
      this.modalData.title = 'تغییر کد هدیه';
      window.$('#CreatCodeModal').modal('show');
    },
    async getGifts({ conditions = {}, page = 1 }) {
      try {
        if (page == '' || parseInt(page) < 1) return;
        const giftServiseInstanse = new giftService();
        const res = await giftServiseInstanse.allGifts({ page, condition: conditions });
        this.giftCodes = res.gifts;
        this.pageController(res);
        console.log(res);
      } catch (err) {
        console.log(err);
      }
    },

    async addEdit(gift) {
      try {
        delete gift.usedCount;
        const giftServiseInstanse = new giftService();
        if (gift._id) {
          gift.id = gift._id;
          await giftServiseInstanse.updateGift({ gift });
          window.notif({ mssg: 'تغییرات اعمال شد', isError: false });
        } else {
          await giftServiseInstanse.createGift({ gift });
          window.notif({ mssg: 'کد ساخته شد', isError: false });
        }
        window.$('#CreatCodeModal').modal('hide');
        this.getGifts({ conditions: {} });
      } catch (err) {
        console.log(err.response);
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },

    async deleteCode(gift) {
      try {
        const giftServiseInstanse = new giftService();
        await giftServiseInstanse.deleteGift({ id: gift._id });
        window.$('#CreatCodeModal').modal('hide');
        this.getGifts({ conditions: {} });
        window.notif({ mssg: 'کد هدیه حذف شد', isError: false });
      } catch (error) {
        console.log(error);
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },

    pageController(res) {
      this.page.count = res.count;
      this.page.current = res.currentPage;
      this.page.total = res.totalPages;
      if (this.page.current == this.page.total) {
        this.page.next = '';
      } else {
        this.page.next = parseInt(this.page.current) + 1;
      }
      if (this.page.current == 1) {
        this.page.pre = '';
      } else {
        this.page.pre = this.page.current - 1;
      }
    },
  },
};
</script>
